import React, { useState } from 'react';

function LengthConverter() {
  const [value, setValue] = useState('');
  const [conversionType, setConversionType] = useState('inToFt');
  const [result, setResult] = useState('');

  const conversions = [
    { id: 'inToFt', name: 'Inches to Feet', formula: val => val / 12 },
    { id: 'ftToIn', name: 'Feet to Inches', formula: val => val * 12 },
    { id: 'mToFt', name: 'Meters to Feet', formula: val => val * 3.28084 },
    { id: 'ftToM', name: 'Feet to Meters', formula: val => val * 0.3048 },
    { id: 'cmToIn', name: 'Centimeters to Inches', formula: val => val * 0.393701 },
    { id: 'inToCm', name: 'Inches to Centimeters', formula: val => val * 2.54 },
    { id: 'kmToMi', name: 'Kilometers to Miles', formula: val => val * 0.621371 },
    { id: 'miToKm', name: 'Miles to Kilometers', formula: val => val * 1.60934 }
  ];

  const handleConvert = () => {
    if (!value || isNaN(value)) {
      setResult('Please enter a valid number');
      return;
    }

    const conversion = conversions.find(c => c.id === conversionType);
    if (conversion) {
      const convertedValue = conversion.formula(parseFloat(value));
      const fromUnit = conversion.name.split(' to ')[0].toLowerCase();
      const toUnit = conversion.name.split(' to ')[1].toLowerCase();
      setResult(`${value} ${fromUnit} = ${convertedValue.toFixed(2)} ${toUnit}`);
    }
  };

  return (
    <div className="converter">
      <h2>Length Converter</h2>
      <select value={conversionType} onChange={(e) => setConversionType(e.target.value)}>
        {conversions.map(conversion => (
          <option key={conversion.id} value={conversion.id}>
            {conversion.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={`Enter ${conversionType.split('To')[0].replace(/([A-Z])/g, ' $1').trim().toLowerCase()}`}
      />
      <button onClick={handleConvert}>Convert</button>
      {result && <div className="result">{result}</div>}
    </div>
  );
}

export default LengthConverter;
